import { type PropsWithChildren, useMemo } from 'react';
import { buildContext } from '@toss/react';
import { useUser } from '@/lib/auth';
import { useCountryCode } from '@/shared/hooks';
import { UserPlanManager } from './UserPlanManager';
export const [UserPlanManagerContextProvider, useUserPlanManager] = buildContext<{
  userPlanManager: UserPlanManager;
}>('UserPlanManager');
export const UserPlanManagerProvider = ({
  children
}: PropsWithChildren) => {
  const {
    user
  } = useUser();
  const {
    countryCode
  } = useCountryCode();
  const userPlanType = user?.planType ?? 'FREE';
  const userPlanManager = useMemo(() => new UserPlanManager(countryCode, userPlanType), [countryCode, userPlanType]);
  return <UserPlanManagerContextProvider userPlanManager={userPlanManager} data-sentry-element="UserPlanManagerContextProvider" data-sentry-component="UserPlanManagerProvider" data-sentry-source-file="UserPlanManagerProvider.tsx">
      {children}
    </UserPlanManagerContextProvider>;
};